"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var gtm_sites_codes_1 = require("../config/gtm-sites-codes");

var idGTM = 'GTM-NC965ZD';
var defaultDataLayerName = 'dataLayer';

var dataLayerScript = function dataLayerScript(_ref) {
  var dataLayer = _ref.dataLayer,
      dataLayerName = _ref.dataLayerName;
  return "\n    window.".concat(dataLayerName, " = window.").concat(dataLayerName, " || [];\n    window.").concat(dataLayerName, ".push(").concat(JSON.stringify(dataLayer), ")");
};

var TargetingDataScript = function TargetingDataScript(targetingData) {
  return "window.targetingData = ".concat(JSON.stringify(targetingData), ";");
};

var tags = function tags(_ref2) {
  var id = _ref2.id,
      events = _ref2.events,
      dataLayer = _ref2.dataLayer,
      dataLayerName = _ref2.dataLayerName;

  /* eslint-disable no-console */
  if (!id) console.warn('_utils: GTM', 'GTM Id is required');
  var script = "if(navigator.userAgent.indexOf('Chrome-Lighthouse') == -1){(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n  new Date().getTime(),event:'gtm.js',".concat(JSON.stringify(events).slice(1, -1), "});var f=d.getElementsByTagName(s)[0],\n  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n  })(window,document,'script','").concat(dataLayerName, "','").concat(id, "');}");
  var scriptGTM = "if(navigator.userAgent.indexOf('Chrome-Lighthouse') == -1){(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n  new Date().getTime(),event:'gtm.js',".concat(JSON.stringify(events).slice(1, -1), "});var f=d.getElementsByTagName(s)[0],\n  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n  })(window,document,'script','").concat(dataLayerName, "','").concat(idGTM, "');}");
  var iframe = "<iframe loading=\"lazy\" src=\"https://www.googletagmanager.com/ns.html?id=".concat(id, "\"\n height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>");
  var iframeGMT = "<iframe loading=\"lazy\" src=\"https://www.googletagmanager.com/ns.html?id=".concat(idGTM, "\"\n height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>");
  var dataLayerVar = dataLayerScript({
    dataLayer: dataLayer,
    dataLayerName: dataLayerName
  });
  return {
    script: script,
    scriptGTM: scriptGTM,
    iframe: iframe,
    iframeGMT: iframeGMT,
    dataLayerVar: dataLayerVar
  };
};

var scripting = function scripting(_ref3) {
  var type = _ref3.type,
      script = _ref3.script,
      attributes = _ref3.attributes;

  /**
   * Teniendo un type y un script creamos el HTML element
   */
  var s = document.createElement(type);
  s.innerHTML = script;

  if (attributes) {
    Object.keys(attributes).forEach(function (key) {
      s.setAttribute(key, attributes[key]);
    });
  }

  return s;
};

var gtm = function gtm(args) {
  /**
   * Creamos todos los HTML elements que posteriormente seran insertados
   */
  var snippets = tags(args);

  var script = function script() {
    return scripting({
      type: 'script',
      script: snippets.script,
      attributes: {
        defer: ''
      }
    });
  };

  var scriptGTM = function scriptGTM() {
    return scripting({
      type: 'script',
      script: snippets.scriptGTM,
      attributes: {
        defer: ''
      }
    });
  };

  var noScript = function noScript() {
    return scripting({
      type: 'noscript',
      script: snippets.iframe
    });
  };

  var noScriptGTM = function noScriptGTM() {
    return scripting({
      type: 'noscript',
      script: snippets.iframeGMT
    });
  };

  var dataScript = function dataScript() {
    return scripting({
      type: 'script',
      script: snippets.dataLayerVar,
      attributes: {
        defer: ''
      }
    });
  };

  return {
    script: script,
    scriptGTM: scriptGTM,
    noScript: noScript,
    noScriptGTM: noScriptGTM,
    dataScript: dataScript
  };
};

var Init = function Init(_ref4) {
  var siteId = _ref4.siteId,
      _ref4$events = _ref4.events,
      events = _ref4$events === void 0 ? {} : _ref4$events,
      dataLayer = _ref4.dataLayer,
      _ref4$dataLayerName = _ref4.dataLayerName,
      dataLayerName = _ref4$dataLayerName === void 0 ? defaultDataLayerName : _ref4$dataLayerName;
  var id = gtm_sites_codes_1.sitesGtmCodes[siteId];
  var gtmScripts = gtm({
    id: id,
    events: events,
    dataLayer: dataLayer || undefined,
    dataLayerName: dataLayerName
  });
  window.gtmScripts = gtmScripts;
  /**
   * Agregamos al dataLayer todos los eventos que deben ser disparados antes de
   * inicializar el tag manager
   */

  if (dataLayer) document.querySelector('head').prepend(gtmScripts.dataScript());
  /**
   * Agregamos al DOM los scripts del tag manager
   */

  document.querySelector('head').prepend(gtmScripts.scriptGTM());
  document.querySelector('head').prepend(gtmScripts.script());
  document.querySelector('body').prepend(gtmScripts.noScriptGTM());
  document.querySelector('body').prepend(gtmScripts.noScript());
  return null;
};

var PushTargetingData = function PushTargetingData(targetingData) {
  if (window.targetingData) {
    window.targetingData = Object.assign(Object.assign({}, window.targetingData), targetingData);
    return window.targetingData;
  }

  var script = TargetingDataScript(targetingData);
  var dataScript = scripting({
    type: 'script',
    script: script
  });
  document.head.appendChild(dataScript);
  return window.targetingData;
};

var Push = function Push(dataLayer) {
  var dataLayerName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultDataLayerName;

  /**
   * Pusheamos un evento
   * En caso de no encontrar el dataLayer creamos uno y lo insertamos al head
   */
  if (window[dataLayerName]) return window[dataLayerName].push(dataLayer);
  var script = dataLayerScript({
    dataLayer: dataLayer,
    dataLayerName: dataLayerName
  });
  var dataScript = scripting({
    type: 'script',
    script: script
  });
  document.head.appendChild(dataScript);
  return null;
};

exports.TagManager = {
  Init: Init,
  Push: Push,
  PushTargetingData: PushTargetingData
};